import ga from '../utils/ga'

export const reportVideoProgress = (eventName, videoSrc) => {
  ga('send', 'event', 'video player - search', eventName, videoSrc)
}



// WEBPACK FOOTER //
// ./common/analytics/videoHiveAnalytics.js